<template>
  <div>
    <component :is="layout"></component>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout'
import EmptyLayout from '@/layouts/EmptyLayout'
import AuthLayout from '@/layouts/AuthLayout'
import StartLayout from '@/layouts/StartLayout'

export default {
  name: 'App',
  components: {
    'main-layout': MainLayout,
    'empty-layout': EmptyLayout,
    'auth-layout': AuthLayout,
    'start-layout': StartLayout,
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || 'empty') + '-layout'
    },
  },
}
</script>

<style>
@import url('https://use.typekit.net/ccc8dux.css');

/* .v-data-table { */
/* font-family: 'Transducer-condensed', 'Avantgarde', 'TeX Gyre Adventor', 'URW Gothic L', sans-serif; */
/* font-family: 'itc-avant-garde-gothic-pro', sans-serif; */
/* font-family: 'kallisto', 'Avantgarde', 'TeX Gyre Adventor', 'URW Gothic L', sans-serif; */
/* font-family: 'kallisto', sans-serif; */
/* }
.v-data-table .v-data-table__wrapper table tr td {
  font-size: 12px !important;
}
.v-data-table .v-data-table__wrapper table tr th {
  font-size: 12px !important;
}
.v-btn{
  font-family: 'Transducer-condensed', sans-serif;
  font-family: 'itc-avant-garde-gothic-pro', sans-serif;
}
.v-list{
  font-family: 'itc-avant-garde-gothic-pro', sans-serif;
}
.v-card .v-card__title{
  font-family: 'itc-avant-garde-gothic-pro', sans-serif;
  font-size: 22px;
}
.v-card .v-card__text{
  font-family: 'itc-avant-garde-gothic-pro', sans-serif;
}
.v-tab{
  font-family: 'itc-avant-garde-gothic-pro', sans-serif !important;
}
.v-btn .v-btn__content{
  font-size: 10px;
}
.v-list .v-list-item .v-list-item__content .v-list-item__subtitle{
  font-size: 12px;
}
.v-list .v-list-item .v-list-item__action .v-chip{
  font-size: 12px;
} */
.v-btn {
  text-transform: none;
}
.v-col {
  font-family: 'Avantgarde', 'TeX Gyre Adventor', 'URW Gothic L', sans-serif;
}
.v-row {
  font-family: 'Avantgarde', 'TeX Gyre Adventor', 'URW Gothic L', sans-serif;
}
.v-card {
  font-family: 'Avantgarde', 'TeX Gyre Adventor', 'URW Gothic L', sans-serif;
}
.v-card-title {
  font-family: 'Avantgarde', 'TeX Gyre Adventor', 'URW Gothic L', sans-serif;
}
.v-input {
  font-family: 'Avantgarde', 'TeX Gyre Adventor', 'URW Gothic L', sans-serif;
}
.v-select {
  font-family: 'Avantgarde', 'TeX Gyre Adventor', 'URW Gothic L', sans-serif;
  /* color: #0055a5 !important; */
}
.v-combobox {
  font-family: 'Avantgarde', 'TeX Gyre Adventor', 'URW Gothic L', sans-serif;
  /* color: #0055a5 !important; */
}
/* .v-input .v-input__control .v-input__slot .v-select__slot{
  font-family: 'Avantgarde', 'TeX Gyre Adventor', 'URW Gothic L', sans-serif;
  color: #0055a5 !important;
}
.v-input{
  font-family: 'Avantgarde', 'TeX Gyre Adventor', 'URW Gothic L', sans-serif;
  color: #0055a5 !important;
} */
.vue-notification-template {
  font-family: 'Avantgarde', 'TeX Gyre Adventor', 'URW Gothic L', sans-serif;
  font-size: 16px;
  border-radius: 5px;
}
</style>
